export default "__VITE_ASSET__D455ymRG__"